import list from 'modules/bot/list/botListReducers';
import form from 'modules/bot/form/botFormReducers';
import view from 'modules/bot/view/botViewReducers';
import messages from 'modules/bot/messages/botMessagesReducers';
import destroy from 'modules/bot/destroy/botDestroyReducers';
import importerReducer from 'modules/bot/importer/botImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  messages,
  destroy,
  importer: importerReducer,
});
